//
// ReportController.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../lib";
import "./BIRDModelController";
import "../util/mediaTarget/WindowSize";
import "../models/state/SASReportState";
import "../models/SASReport";
import "./view/HeaderController";
import "@sas-dvr/ltjs-commons/models/warnings/Warning";
import "./view/SectionController";
import "../util/SASReportConfiguration";
import "@sas-dvr/ltjs-commons/styles/NamedStyleMap";
import "@sas-dvr/ltjs-commons/styles/StyleChain";
import "../models/results/Result";
import "../models/visualElements/VisualElement";
import "./visualElements/VisualElementController";
import "../models/view/Section";
import "./interactions/InteractionEvent";
import "../util/displayRules/DisplayRuleInfo";
import "@sas-dvr/ltjs-commons/util/Dimension";
import "./ChangeController";
import "./ReportPrivacyController";
import "../util/ReportParameterValue";
import "./view/VisualController";
import "./view/UseFlowLayout";

var ReportController = createModule("BIRD::ReportController", ["BIRD::BIRDModelController"], EventDispatcher, [
    {
        CURRENT_SECTION_CHANGED: 50036,
        CONVERTED_TO_FLOW_LAYOUT: 50041,
        PRIVACY_CHECK_COMPLETE: 50042,
        INVALID_REPORT: 50018,
        INVALID_REPORT_STATE: 50019,
        REPORT_STATE_READY: 50039,
        INVALID_TEXT: 50020,
        REPORT_INITIALIZED: 50040,
        SECTION_LINKING_CLEAR: 50037,
        SECTION_CONTROLLERS_CHANGED: 50038,
        INVALID_SECTION: 50021,
    },
    ,
    ,
    {
        windowSize: 4,
        currentSectionIndex: 4,
        reportState: 1,
        maximumNumberOfActiveSections: 4,
    },
    {
        updateReportState: [0],
        initializeParameterValues: [0],
        saveCurrentSectionIndex: [0],
        supportsFeature: [2,4],
        setReportParameterValue: [0,1],
        getNamedStyleMap: [1],
        setCurrentSelectedController: [0,1],
        isHiddenSection: [2,7],
        addSectionLinkInfo: [0,1],
        removeLatestSectionLinkInfos: [0,4],
        isStateInvalidatedDueToReportChange: [2],
        getSASReportConfiguration: [1],
        getInitialReportParameterValues: [[1]],
        setFlowLayoutUsage: [0,4],
        triggerInteractions: [0],
        saveUserState: [0],
        getVisibleSections: [[1]],
        setFeatureTypeFlag: [0,4,2],
        getDisplayRuleInfos: [[1]],
        getFullyQualifiedPathToStateDirectory: [7],
        setNarrowScreenLayout: [0],
        getCurrentSectionLinks: [[1]],
        getModel: [1],
        getFullyQualifiedPathToCurrentSectionIndexStateFile: [7],
        getVisualElementControllerForVisualElementName: [1,7],
        getCurrentSectionController: [1],
        getKeyVisual: [1],
        popHiddenSection: [0],
        getFixedBodyWidth: [1],
        setReportFiltersActive: [0,2],
        getViewControllerForName: [1,7],
        hasAlertableState: [2],
        getViewSetControllers: [[1]],
        getReportLinkInfo: [1],
        getDataSourceLabels: [[7]],
        getIndexOfSectionWithName: [4,7],
        getAllSectionControllers: [[1]],
        prepareReportState: [0],
        isNarrowScreenLayout: [2],
        hasPrecisionLayouts: [2],
        saveState: [0],
        resetScreenLayout: [0],
        getWarnings: [[1]],
        setSelectedVisual: [0,1],
        removeSectionLinkInfo: [0],
        getReportStyleChain: [1],
        getReportPrivacyController: [1],
        getFlowLayoutUsage: [4],
        getActiveSectionController: [1],
        areReportFiltersActive: [2],
        getFixedBodyHeight: [1],
        getReportPromptStyleChain: [1],
        areLatestLinkForHeaderValue: [2],
        getChangeController: [1],
        getHeaderController: [1],
        getNumberOfSections: [4],
        getCurrentSectionLinksForCurrentSection: [[1]],
        getResultForDataDefinitionName: [1,7],
        getAllVisualElements: [[1]],
        undoFlowLayout: [0],
        getHiddenSectionControllerForName: [1,7,1],
    },
    {
        _create: [4,1],
    },
    ,
]);
export default ReportController;
